<mat-dialog-content>
    <app-employee-schedule [employeeId]="employeeId" [atDate]="atDate" [scheduleId]="scheduleId"></app-employee-schedule>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button (click)="close()">Stäng</button>
</mat-dialog-actions>
